export default "__VITE_ASSET__bf1ef98e__"